import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/terzotempo/terzotempo/components/calendario/CalendarioClientView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/terzotempo/terzotempo/components/common/WhatsappLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/terzotempo/terzotempo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/terzotempo/terzotempo/node_modules/next/dist/client/image-component.js");
